module.exports = __webpack_public_path__ + "assets/fa-solid-900.b15db15f746f29ffa02638cb455b8ec0.woff2";